/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import Handsontable from 'handsontable';

function readOnlyRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.style.color = '#000';
  td.style.background = '#EEE';
  return td;
}

export const columns = [
  {
    data: 'tableId',
    type: 'numeric',
    width: 40,
    readOnly: true,
    renderer: readOnlyRenderer
  },
  {
    data: 'empLastName',
    type: 'text',
    readOnly: true,
    renderer: readOnlyRenderer
  },
  {
    data: 'empFirstName',
    type: 'text',
    readOnly: true,
    renderer: readOnlyRenderer
  },
  {
    data: 'contractName',
    type: 'text',
    readOnly: true,
    renderer: readOnlyRenderer
  },
  {
    data: 'begindate',
    type: 'date',
    dateFormat: 'YYYY-MM-DD'
  },
  {
    data: 'enddate',
    type: 'date',
    dateFormat: 'YYYY-MM-DD'
  },
  {
    data: 'value',
    type: 'numeric'
  },
  {
    data: 'unitTransId',
    type: 'text',
    readOnly: true,
    renderer: readOnlyRenderer
  }
];

export const colHeaders = [
  'id',
  'last_name',
  'first_name',
  'Contract',
  'begin_date',
  'end_date',
  'Value',
  'Unit'
];
